/* QUILTZA koleksiyon: filtre paneli, sıralama, 3/4 kolon görünümü. Vanilla JS, native GET form. */
(function () {
  function init(root) {
    if (!root || root.dataset.qzReady) return;
    root.dataset.qzReady = 'true';
    var form = root.querySelector('[data-qz-collection-form]');
    var toggle = root.querySelector('[data-qz-filter-toggle]');
    var panel = root.querySelector('[data-qz-filter-panel]');
    var sort = root.querySelector('[data-qz-sort]');
    var grid = root.querySelector('[data-qz-grid]');

    function setOpen(open) {
      if (!toggle || !panel) return;
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      panel.hidden = !open;
      if (open) {
        var first = panel.querySelector('input:not([disabled]), button, a');
        if (first) first.focus();
      }
    }
    if (toggle && panel) {
      toggle.addEventListener('click', function () { setOpen(toggle.getAttribute('aria-expanded') !== 'true'); });
      root.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') { setOpen(false); toggle.focus(); }
      });
    }

    if (form) {
      form.addEventListener('submit', function () {
        /* Boş fiyat alanlarını gönderme: native URL temiz kalsın */
        form.querySelectorAll('input[type="number"]').forEach(function (i) { if (i.value === '') i.disabled = true; });
      });
    }
    if (sort && form) {
      sort.addEventListener('change', function () {
        if (typeof form.requestSubmit === 'function') form.requestSubmit(); else form.submit();
      });
    }

    var buttons = root.querySelectorAll('[data-qz-view]');
    if (grid && buttons.length) {
      var saved = null;
      try { saved = localStorage.getItem('qz-collection-cols'); } catch (e) {}
      function apply(cols) {
        grid.dataset.cols = cols;
        root.style.setProperty('--qz-cols-desktop', cols);
        buttons.forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.qzView === String(cols) ? 'true' : 'false'); });
      }
      if (saved === '3' || saved === '4') apply(saved);
      buttons.forEach(function (b) {
        b.addEventListener('click', function () {
          apply(b.dataset.qzView);
          try { localStorage.setItem('qz-collection-cols', b.dataset.qzView); } catch (e) {}
        });
      });
    }
  }
  function boot() { document.querySelectorAll('.qz-collection').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
